import { Fragment, useState } from 'react';
import { BlockWrapper, defineBlock } from '@smartfire/js-block-engine';
import { Alert } from '@mui/material';
import { NotificationsNone } from '@mui/icons-material';
import { formatPrice } from '../../shared/woocommerce/price';
import { __ } from '../../shared/tools';
import { Button } from '../../button/block';
import { ProductImagesSlider } from './image-slider';
import { ProductDeclinaisons } from './declinaisons';
import { CartControl } from './cart-control';
import { ProductStockAlertForm } from './stock-alert-form';
import { ProductSlider } from './product-slider';
import { ReadMore } from './../../shared/components/utilities/read-more/ReadMore';

import style from './style.module.scss';

export const ProductBlock = ({ product = {}, settings = {}, activeLang, defaultUsd }) => {
    return (
        <BlockWrapper.Article className={style.product}>
            <ProductMain product={product} settings={settings} defaultUsd={defaultUsd} />
            <ProductDetails product={product} settings={settings} />
            {/* <ProductSliders product={product} activeLang={activeLang} /> */}
        </BlockWrapper.Article>
    );
};

const ProductMain = ({ product = {}, settings = {}, defaultUsd = {}}) => {
    const {
        declinaisons,
        description,
        isPurchasable,
        name,
        regularPrice,
        salePrice,
        stock,
        subtitle,
        technical_description,
    } = product;
    const { storeLocatorPage } = settings;
    const [price, setPrice] = useState({ regular: regularPrice, sale: salePrice });
    const [isInStock, setIsInStock] = useState(true);
    const [variationId, setVariationId] = useState(0);

    return (
        <div className={style.main}>
            <ProductImagesSlider images={product.images} />
            <div className={style.infos} data-default-usd={defaultUsd}>
                {name && <h1 className={style.title}>{name}</h1>}
                {subtitle && subtitle.length > 0 && <p className={style.material}>{subtitle}</p>}
                {price && price.regular > 0 &&
                    <ProductPrice
                        price={price}
                        {...(defaultUsd && { defaultUsd })} // Conditionally add `defaultUsd` if true
                    />
                }
                {(description || technical_description) && (
                    <div className={style.description}>
                        <span className={style.subtitle}>{__('Description')}</span>
                        <ReadMore linesCount="2">
                            {description}
                            {technical_description && technical_description.length > 0 && ' ' + technical_description}
                        </ReadMore>
                    </div>
                )}
                {declinaisons && declinaisons.length > 0 && <ProductDeclinaisons product={product} />}
                {isPurchasable && (
                    <CartControl
                        product={product}
                        setPrice={setPrice}
                        isInStock={isInStock}
                        setIsInStock={setIsInStock}
                        setVariationId={setVariationId}
                        settings={settings}
                    />
                )}
                {!isPurchasable && storeLocatorPage && (
                    <div className={style.findStore}>
                        <Button
                            text={__('Trouver une boutique', 'paraboot')}
                            link={storeLocatorPage.url}
                            className={style.findStoreBtn}
                            type="filled"
                        />
                        {/* <p>{__('La livraison est aujourdhui possible uniquement dans les pays de la zone €.')}</p> */}
                    </div>
                )}
                {(!stock.isInStock || !isInStock) && (
                    <div className={style.out_of_stock}>
                        <Alert severity="error" className={style.alert} icon={<NotificationsNone fontSize="inherit" />}>
                            {__('Soyez alerté par email une fois le produit à nouveau disponible.')}
                        </Alert>
                        <ProductStockAlertForm productId={variationId ? variationId : product.id} />
                    </div>
                )}
            </div>
        </div>
    );
};

const ProductPrice = ({ price, defaultUsd }) => {
    let currencyData = {};

    if (defaultUsd) {
        currencyData = {
            suffix: '$'
        }
    }

    return (
        <p className={style.prices}>
            {price.sale && price.sale < price.regular ? (
                <Fragment>
                    <span className={style.priceCrossed}>{formatPrice(price.regular, currencyData)}</span>
                    <span className={style.price}>{formatPrice(price.sale, currencyData)}</span>
                </Fragment>
            ) : (
                <span className={style.price}>{formatPrice(price.regular, currencyData)}</span>
            )}
        </p>
    );
};

const ProductDetails = ({ product }) => {
    const { image_lifestyle } = product;

    return (
        <Fragment>
            {image_lifestyle && (
                <img className={style.image_lifestyle} src={image_lifestyle.src} alt={image_lifestyle.alt} />
            )}
        </Fragment>
    );
};

export const ProductSliders = ({ product, activeLang }) => {
    const { crossSellingIds } = product;

    return crossSellingIds && crossSellingIds.length > 0 ? (
        <div className={style.sliders}>
            <p className={style.subtitle}>{__('Découvrez également')}</p>
            <ProductSlider activeLang={activeLang} productIds={crossSellingIds} />
        </div>
    ) : null;
};

export default defineBlock({
    Block: ProductBlock,
    setup: {
        title: 'Produit',
        parent: [],
    },
    smartProps: {},
});
